import { useRedux } from "hooks";
import { MemberRole, TaskStatus, WpPostInfo, WpPostInfoTag, WpSliceData } from "./redux/workplace/wpTypes";
import { createSelector } from "reselect";
import AsyncSelect from "react-select/async";
import ReactDOM from "react-dom";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { TABS, WpModes } from "./constants";
import { APIClient } from "api/apiCore";
import * as url from "api/urls"
import { backdropStyle, modalStyle } from "DialogProviderShare";
import TaskFormField, { } from "../src/pages/Dashboard/Workplace/TaskFormField";
import { Utils } from "helpers/utils";
import { debounce } from "lodash";
import ReactQuill from "react-quill";
import { DropdownOption, TaskRecurance2Data, TaskFormFieldData, TaskRecurance2DataDef } from "types";
import { RecuranceModes } from "const";
import SelectDropdownAsyncWpTags from "components/SelectDropdownAsyncWpTags";
import AppSimpleBar from "components/AppSimpleBar";
import { FormControlLabel, Switch } from "@mui/material";
import Loader from "components/Loader";

export function TaskRecurancePortal({ postId, onClose }: { postId: string, onClose: (v: any) => void }) {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (state: any) => state.Profile2,
    (wp: WpSliceData, p2: any) => ({
      // activePostInfo: wp.activePostInfo,
      curUserId: p2.userId,
      isAdmin: p2.isAdmin,
      activePost: wp.activePostInfo,
    })
  );

  const { /*activePostInfo,*/ curUserId, isAdmin, activePost } = useAppSelector(storeData);

  const [taskData, setTaskData] = useState<TaskFormFieldData>({
    taskName: "",
    enabled: true,
    projectId: null,
    assignerId: curUserId,
    respondId: null,
    requestBy: null,
    planFinishedDate: null,
    createSubTaskFromTaskId: null,
  });

  const toNumberArray = (value?: string) => value ? value.split(',').map(x => Number(x)).filter(x => !isNaN(x)) : [];
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const setTaskDataFromApi = (apiRs: any, takeFromActivePost: boolean) => {
    // console.log('apiRs:', apiRs);
    if (takeFromActivePost) {
      setTaskData(prev => ({
        ...prev,
        taskName: activePost.title,
        projectId: activePost.projectId
      }));
      // setRecurance1(data.recuances?.length > 0 ? data.recuances[0] : { recuranceMode: RecuranceModes.None, dailyOnTime: "01:00" });
      // setRecurance2(data.recuances?.length > 1 ? data.recuances[1] : { recuranceMode: RecuranceModes.None, dailyOnTime: "01:00" });
      // setRecurance3(data.recuances?.length > 2 ? data.recuances[2] : { recuranceMode: RecuranceModes.None, dailyOnTime: "01:00" });
      // setTagIds(data.tagIds);
    } else {

      apiRs = { ...apiRs, requestBy: apiRs.requesterId };
      // console.log('apiRs:', apiRs);
      const data = apiRs;
      var tagIds = apiRs.tagIds?.split(',');
      var tagNames = apiRs.tagNames?.split('|');
      data.tagIds = tagIds?.filter((x: any) => x != '').map((id: number, index: number) => ({ value: id, label: tagNames?.[index] ?? '' })) ?? [];
      // console.log('data.tagIds:', data.tagIds);
      // data.recuances = data.recuances.map((e: any) => ({
      //   ...e,
      //   startDate: Utils.ConvertApiDate(e.startDate),
      //   expireDate: Utils.ConvertApiDate(e.expireDate),
      //   specificDate: Utils.ConvertApiDate(e.specificDate),
      //   lastTaskCreate: Utils.ConvertApiDate(e.lastTaskCreate),
      //   dailyExceptDay: toNumberArray(e.dailyExceptDay),
      //   dailyExceptWeekDay: toNumberArray(e.dailyExceptWeekDay),
      //   weeklyEveryWeekDay: toNumberArray(e.weeklyEveryWeekDay),
      //   weeklyExceptDay: toNumberArray(e.weeklyExceptDay),
      //   monthlyEveryDay: toNumberArray(e.monthlyEveryDay),
      //   monthlyExceptWeekDay: toNumberArray(e.monthlyExceptWeekDay),
      //   monthlyExceptMonth: toNumberArray(e.monthlyExceptMonth),
      //   yearlyEveryDay: toNumberArray(e.yearlyEveryDay),
      //   yearlyEveryMonth: toNumberArray(e.yearlyEveryMonth),
      // }));
      data.recuance = { ...apiRs };
      // console.log('rs:', data);
      setTaskData(data);
      setRecurance(data.recuance ?? TaskRecurance2DataDef());
      // setRecurance1(data.recuances?.length > 0 ? data.recuances[0] : { recuranceMode: RecuranceModes.None, dailyOnTime: "01:00" });
      // setRecurance2(data.recuances?.length > 1 ? data.recuances[1] : { recuranceMode: RecuranceModes.None, dailyOnTime: "01:00" });
      // setRecurance3(data.recuances?.length > 2 ? data.recuances[2] : { recuranceMode: RecuranceModes.None, dailyOnTime: "01:00" });
      setTagIds(data.tagIds);
    }
  }

  useEffect(() => {
    // console.log('taskData:', taskData);
  }, [taskData]);

  useEffect(() => {
    try {
      if (postId) {
        setIsLoading(true);
        new APIClient().fnPostForm(url.WP_LOAD_TASK_RECURRANCE, { postId })
          .then(rs => {
            // console.log('rs:', rs);
            if (rs && rs.taskId) {
              setTaskDataFromApi(rs, false);
            } else {
              setTaskDataFromApi(null, true);
            }
            setIsLoading(false);
          })
          .catch(e2 => {
            Utils.HandleException(e2, true);
            setIsLoading(false);
          });
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }, [postId]);

  const onTaskFormChanged = useCallback(
    (key: keyof TaskFormFieldData, value: any) => {
      // console.log(`onTaskFormChanged key = ${key}, value = ${value}`);
      // setTaskData(prev => ({ ...prev, [key]: value }));
      setTaskData(prev => {
        const updated = { ...prev, [key]: value };
        Utils.WpDraft_SaveTk(updated);

        return updated;
      });

    }, []
  );

  const [recurance, setRecurance] = useState<TaskRecurance2Data>(TaskRecurance2DataDef());
  // const [recurance1, setRecurance1] = useState<TaskRecuranceDtlData>({ recuranceMode: RecuranceModes.None, dailyOnTime: "01:00" });
  // const [recurance2, setRecurance2] = useState<TaskRecuranceDtlData>({ recuranceMode: RecuranceModes.None, dailyOnTime: "01:00" });
  // const [recurance3, setRecurance3] = useState<TaskRecuranceDtlData>({ recuranceMode: RecuranceModes.None, dailyOnTime: "01:00" });
  const onRecuranceChange = (/*index: number,*/ patch: Partial<TaskRecurance2Data>) => {
    // console.log('patch:', index, patch);
    // if (index === -1 || index === 1) setRecurance1(prev => ({ ...prev, ...patch }));
    // if (index === -1 || index === 2) setRecurance2(prev => ({ ...prev, ...patch }));
    // if (index === -1 || index === 3) setRecurance3(prev => ({ ...prev, ...patch }));
    setRecurance(prev => ({ ...prev, ...patch }));
  }

  // useEffect(() => {
  //   console.log('r1:', recurance1);
  // }, [recurance1]);
  // useEffect(() => {
  //   console.log('r2:', recurance2);
  // }, [recurance2]);
  // useEffect(() => {
  //   console.log('r3:', recurance3);
  // }, [recurance3]);

  const [tagIds, setTagIds] = useState<DropdownOption[]>([]);
  const onTagIdChanged = (values: DropdownOption[]) => {
    setTagIds(values);
  }

  let errMsg = "";
  const err = (msg?: string): boolean => {
    alert(msg ?? errMsg);
    return false;
  }

  const getDataForSave = () => {
    const postId2Save = postId ? postId : Utils.GetUniqueId();
    const r1 = { ...recurance, recuranceText: Utils.GetTaskRecuranceText(recurance) } as any;
    // const toSave = {
    //   taskId: postId2Save,
    //   taskName: taskData.taskName ?? "",
    //   taskDescription: taskData.taskDescription ?? "",
    //   projectId: taskData.projectId ?? null,
    //   tagIds: (tagIds ?? []).map(x => x.value).join(','),
    //   assignerId: (taskData.assignerId ?? null),
    //   respondId: (taskData.respondId ?? null),
    //   requesterId: (taskData.requestBy ?? null),
    //   // finishedByNum: taskData.finishedByNum ?? null,
    //   // finishedByUnit: taskData.finishedByUnit ?? null,
    //   enabled: taskData.enabled ?? false,
    //   // recuances: [r1, r2, r3],
    //   // recuance: r1
    // }
    // console.log('getDataForSave:', { r1, taskData });
    // const toSave2 = { ...toSave, ...r1, tagIds: toSave.tagIds };
    const toSave2 = {
      ...r1,
      taskId: postId2Save,
      taskName: taskData.taskName ?? "",
      taskDescription: taskData.taskDescription ?? "",
      projectId: taskData.projectId ?? null,
      assignerId: (taskData.assignerId ?? null),
      respondId: (taskData.respondId ?? null),
      requesterId: (taskData.requestBy ?? null),
      enabled: taskData.enabled ?? false,
      tagIds: (tagIds ?? []).map(x => x.value).join(','),
    };
    return toSave2;
  }

  const onSave = async () => {
    try {

      // const postId2Save = postId ? postId : Utils.GetUniqueId();
      // const toSave: any = structuredClone({
      //   ...taskData,
      //   recurance1: { ...recurance1, postId: postId2Save, recuranceText: Utils.GetTaskRecuranceText(recurance1) },
      //   recurance2: { ...recurance2, postId: postId2Save, recuranceText: Utils.GetTaskRecuranceText(recurance1) },
      //   recurance3: { ...recurance3, postId: postId2Save, recuranceText: Utils.GetTaskRecuranceText(recurance1) },
      //   tagIds: tagIds.map(x => x.value),
      // });

      // const r1 = { ...recurance, recuranceText: Utils.GetTaskRecuranceText(recurance) } as any;
      // // const r1 = { ...recurance1, recuranceText: Utils.GetTaskRecuranceText(recurance1) } as any;
      // // const r2 = { ...recurance2, recuranceText: Utils.GetTaskRecuranceText(recurance2) } as any;
      // // const r3 = { ...recurance3, recuranceText: Utils.GetTaskRecuranceText(recurance3) } as any;
      // const toSave = {
      //   taskId: postId2Save,
      //   taskName: taskData.taskName ?? "",
      //   taskDescription: taskData.taskDescription ?? "",
      //   projectId: taskData.projectId ?? null,
      //   tagIds: (tagIds ?? []).map(x => x.value).join(','),
      //   assignerId: (taskData.assignerId ?? null),
      //   respondId: (taskData.respondId ?? null),
      //   requesterId: (taskData.requestBy ?? null),
      //   // finishedByNum: taskData.finishedByNum ?? null,
      //   // finishedByUnit: taskData.finishedByUnit ?? null,
      //   enabled: taskData.enabled ?? false,
      //   // recuances: [r1, r2, r3],
      //   // recuance: r1
      // }
      // toSave.recuances?.forEach(e => {
      //   e.dailyExceptDay = e.dailyExceptDay?.join(',');
      //   e.dailyExceptWeekDay = e.dailyExceptWeekDay?.join(',');
      //   e.weeklyEveryWeekDay = e.weeklyEveryWeekDay?.join(',');
      //   e.weeklyExceptDay = e.weeklyExceptDay?.join(',');
      //   e.monthlyEveryDay = e.monthlyEveryDay?.join(',');
      //   e.monthlyExceptWeekDay = e.monthlyExceptWeekDay?.join(',');
      //   e.monthlyExceptMonth = e.monthlyExceptMonth?.join(',');
      //   e.yearlyEveryDay = e.yearlyEveryDay?.join(',');
      //   e.yearlyEveryMonth = e.yearlyEveryMonth?.join(',');
      // });

      // console.log('taskData:', taskData);
      //  console.log('toSave:', toSave);

      // const toSave2 = { ...toSave, ...r1, tagIds: toSave.tagIds };
      const toSave2 = getDataForSave();

      // checking
      if (!toSave2.taskName) return err('กรุณาระบุ ชื่องาน');
      errMsg = Utils.CheckTaskRecuranceData(toSave2); if (errMsg) return err(errMsg);
      // errMsg = Utils.CheckTaskRecuranceData(r2); if (errMsg) return err(errMsg + ' ของงานประจำแบบที่ 2');
      // errMsg = Utils.CheckTaskRecuranceData(r3); if (errMsg) return err(errMsg + ' ของงานประจำแบบที่ 3');
      if (toSave2.recuranceMode === RecuranceModes.None) return err("ยังไม่ได้ระบุกำหนดเสร็จ");
      if (!toSave2.assignerId) return err('กรุณาระบุผู้มอบหมาย');
      if (!toSave2.respondId) return err('กรุณาระบุเจ้าของงาน');
      // if (!toSave.finishedByNum) return err('กรุณาระบุวันกำหนดเสร็จ');
      // if (!toSave.finishedByUnit) return err('กรุณาระบุหน่วยวันกำหนดเสร็จ');

      // console.log('toSave:', { toSave, r1 });

      const nextDate = await new APIClient().fnPostBody(url.WP_GET_TASK_NEXT_DATE, toSave2);
      // console.log('nextDate:', nextDate);
      if (nextDate.isPass) {
        if (nextDate.nextDate) {
          const rs = await Utils.SweetConfirm('วันที่จะสร้างงานเป็น <span class="text-red">' + Utils.GetDMYHHMM(nextDate.nextDate) + '</span><br/>กำหนดเสร็จเป็น <span class="text-red">' + Utils.GetDMY(nextDate.dueDate) + '</span><br/>ซึ่งวันสร้างผ่านไปแล้ว หากท่านบันทึก งานจะถูกสร้างขึ้นทันที<br/>ต้องการบันทึกหรือไม่?');
          if (!rs.isConfirmed) return;
        } else {
          const rs = await Utils.SweetConfirm('จากการตั้งค่างานประจำ <span class="text-red">ระบบไม่สามารถคำนวณงานถัดไปได้</span> การตั้งค่าอาจไม่ถูกต้อง ต้องการบันทึกหรือไม่');
          if (!rs.isConfirmed) return;
        }
      }



      // saving
      const api = new APIClient();
      setIsLoading(true);
      // api.fnPostBody(url.WP_SAVE_TASK_RECURRANCE, toSave)
      //   .then(rs => {
      //     // console.log('rs:', rs);
      //     setTaskDataFromApi(rs, false);
      //     setIsLoading(false);
      //     onClose(postId2Save);
      //   })
      //   .catch(ex => {
      //     Utils.HandleException(ex, true);
      //     setIsLoading(false);
      //   })
      api.fnPostBody(url.WP_SAVE_TASK_RECURRANCE2, toSave2)
        .then(rs => {
          // console.log('rs:', rs);
          // setTaskDataFromApi(rs, false);
          setIsLoading(false);
          onClose(toSave2.taskId/* postId2Save*/);
        })
        .catch(ex => {
          Utils.HandleException(ex, true);
          setIsLoading(false);
        })
    } catch (e) {
      Utils.HandleException(e, true);
      setIsLoading(false);
    }
  }

  const onViewForcast = () => {
    const data = getDataForSave();
    Utils.ShowNextTaskRecuranceTable(data);
  }

  const fnDel = async () => {
    const rs = await Utils.SweetConfirm("ยืนยันการลบ");
    if (rs.isConfirmed) {
      setIsLoading(true);
      new APIClient().fnPostForm(url.WP_DELETE_TASK_RECURANCE, { taskId: postId })
        .then(rs => {
          setIsLoading(false);
          onClose("del-" + postId);
        })
        .catch(er => {
          setIsLoading(false);
          Utils.HandleException(er, true);
        });

    }
  }

  return ReactDOM.createPortal(
    <div style={backdropStyle} >
      {isLoading && (<Loader />)}
      <div style={modalStyle} >
        <AppSimpleBar style={{ maxHeight: "calc(100vh - 80px)", overflowX: "hidden", overflowY: "auto" }}>
          <TaskFormField
            formData={taskData}
            onFormChanged={onTaskFormChanged} showTaskDescription={true} planFinishedDateMode="CAL"
            showRecurance={true} recurance={recurance} onRecuranceChange={onRecuranceChange}
            selectedTagsIds={tagIds} onTagChanged={onTagIdChanged}
            onViewForcastSchedule={onViewForcast}
          />
        </AppSimpleBar>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 8, borderTop: "dashed 1px var(--m2-line-divider-color)" }}>
          <div>
            {postId && (<button className="btn btn-danger" onClick={fnDel} >ลบ</button>)}
          </div>
          <div className="d-flex justify-content-between" style={{ gap: "6px" }}>
            <button className="btn btn-warning" onClick={() => onClose(null)} >ปิด</button>
            <button className="btn btn-primary" onClick={() => onSave()} >บันทึก</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}